import { Copyright } from 'lego-on-react';
import React from 'react';

export default function () {
    return <Copyright start={2014} />;
}
